import React from 'react'

/**
 * Modal Component (popup)
 *
 * @param homeUrl
 * @param showModal
 * @param content
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const ModalComponent = ({homeUrl, showModal = false, content, onClose}) => {
	return (
		<div className={`form-modal ${showModal ? "show-modal" : ""}`}>
			<div className="modal">

				<div style={{minWidth: '400px', maxWidth: '600px'}} className="modal-content">
					{onClose != undefined && <p onClick={onClose} className="close"><i className="fa fa-times"></i></p>}
					{content}
				</div>

			</div>

		</div>
	)
}

export default ModalComponent
